/** QuickPlan — Bibliothèque intégrée (composants + assemblages types), validée au chargement. */
import { ComponentSchema, TemplateSchema } from '../schema.js';
import alu from './alu.js';
import meuble from './meuble.js';
import rack from './rack.js';
import fixations from './fixations.js';
import templates from './templates.js';

const generic = [
  {
    id: 'gen-boite',
    name: 'Boîte',
    category: 'autre',
    family: 'Formes simples',
    description: 'Pavé W (X) × D (Y) × H (Z), origine au coin minimal. Pour représenter un équipement, une machine, un encombrement.',
    color: '#8a94a3',
    params: [
      { key: 'W', label: 'Largeur', default: 300, min: 1, max: 20000, unit: 'mm' },
      { key: 'D', label: 'Profondeur', default: 300, min: 1, max: 20000, unit: 'mm' },
      { key: 'H', label: 'Hauteur', default: 300, min: 1, max: 20000, unit: 'mm' },
    ],
    parts: [{ type: 'box', size: ['W', 'D', 'H'] }],
    ports: [{ id: 'origine', pos: [0, 0, 0] }, { id: 'dessus', pos: ['W/2', 'D/2', 'H'] }],
    bom: { kind: 'piece', label: '{W}×{D}×{H}' },
  },
  {
    id: 'gen-cylindre',
    name: 'Cylindre',
    category: 'autre',
    family: 'Formes simples',
    description: 'Cylindre vertical Ø D × H, origine au centre de la base.',
    color: '#8a94a3',
    params: [
      { key: 'D', label: 'Diamètre', default: 100, min: 1, max: 10000, unit: 'mm' },
      { key: 'H', label: 'Hauteur', default: 300, min: 1, max: 20000, unit: 'mm' },
    ],
    parts: [{ type: 'cyl', r: 'D/2', h: 'H' }],
    ports: [{ id: 'base', pos: [0, 0, 0] }, { id: 'dessus', pos: [0, 0, 'H'] }],
    bom: { kind: 'piece', label: 'Ø{D}×{H}' },
  },
];

export const BUILTIN_COMPONENTS = [...alu, ...meuble, ...rack, ...fixations, ...generic].map((c) => ComponentSchema.parse(c));
export const BUILTIN_TEMPLATES = templates.map((t) => TemplateSchema.parse(t));
export const BUILTIN_IDS = new Set([...BUILTIN_COMPONENTS, ...BUILTIN_TEMPLATES].map((c) => c.id));

/** Index de recherche : composants du projet > bibliothèque perso > intégrés. */
export function makeLookup(project, custom = []) {
  const map = new Map();
  for (const c of BUILTIN_COMPONENTS) map.set(c.id, c);
  for (const c of custom) map.set(c.id, c);
  for (const c of project?.components ?? []) map.set(c.id, c);
  return (id) => map.get(id) ?? null;
}
